
import React from 'react';
import { useState, useEffect } from "react";
import { useHistory, useParams } from 'react-router-dom';
import Select from "react-select";
import { toast } from "react-toastify";
import LoandSideBar from "../../LoansSideBar"
import swal from "sweetalert";

import loanCss from '../../../../css/loanRegisterECL.module.css'

import Breadcrumb from "../../../../components/Breadcrumb"
import commoncss from "../../../../css/common.module.css"

import {getAllLoanECLScenario, selectLoanECLScenario, getLoanMapping, setEclFields, confirmPDData, confirmLGDData,
        confirmFLFData, calculateECL, viewWorking, addToLoanListing,
        getLoansData,
        } from '../../../../../Bookclosure/Services/ApiHandler'

import  { ReactComponent as PervBtnIcon }  from '../../../../assets/icons/pervECLBtnIcon.svg'
import  { ReactComponent as BreadCrumbsdor }  from '../../../../assets/icons/breadCrumbsDot.svg'
import  { ReactComponent as EditIcon }  from '../../../../assets/icons/editCard.svg'
import  { ReactComponent as CompleteECLIcon }  from '../../../../assets/icons/completeECL.svg'
import  { ReactComponent as Warning }  from '../../../../assets/icons/warningIconLoanRegisterECL.svg'
import  { ReactComponent as RefershIcon }  from '../../../../assets/icons/loanRegisterRefersh.svg'
import  { ReactComponent as LoaderIcon }  from '../../../../assets/icons/loansLoader.svg'
import  { ReactComponent as NextBtnIcon }  from '../../../../assets/icons/rightWhite.svg'

import Table from "../../../../elements/Table"

// Sending Data to Api when user Click on the Next Button

const addLoanToListing = (loanId) => {
    addToLoanListing(loanId,'ECL').then(() => {
        toast.success("Successfully Add to Loan listing.");
    })
}

const ReceivablesRegisterEcl = () => {

    const { id, companyId } = useParams();

    const [loanID, setloanID] = useState(id)
    // const [loanID, setloanID] = useState('6762fea33c390b53069845b4')
    const [companyID, setcompanyID] = useState(companyId)
    // const [companyID, setcompanyID] = useState('6655b5365ce609ea146c5c53')

    // active stage
    const [ActiveStage, setActiveStage] = useState(1)

    const numberofStages = [1, 2, 3, 4, 5, 6, 7]

    // Stage One
    const [stageOneOptions , setStageOneOptions] = useState([])
    const [stageOneScenarioId , setstageOneScenarioId] = useState()

    // stage Two
    const [stageTwoOptions , setstageTwoOptions] = useState([])
    const [stageTwoStageOptionValue , setstageTwoStageOptionValue] = useState()
    const [outStandingLoanAmount , setoutStandingLoanAmount] = useState([])

    // stage Three
    // const [stageThreeData , setstageThreeData] = useState()
    // const [stageThreeTableHeaders , setstageThreeTableHeaders] = useState([])
    // const [stageThreeTableBody , setstageThreeTableBody] = useState([])

    
    // stage Four
    const [stageFourData , setstageFourData] = useState()
    const [stageFourTableHeaders , setstageFourTableHeaders] = useState([])
    const [stageFourTableBody , setstageFourTableBody] = useState([])

    // stage Five
    // const [stageFiveData , setstageFiveData] = useState()
    // const [stageFiveTableHeaders , setstageFiveTableHeaders] = useState([])
    // const [stageFiveTableBody , setstageFiveTableBody] = useState([])

    // stage Six
    const [StageSixPostition, setStageSixPostition] = useState(1)
    const [StageSixData, setStageSixData] = useState()
    const [stageSixTableHeaders , setstageSixTableHeaders] = useState([])
    const [stageSixTableBody , setstageSixTableBody] = useState([])


    const computeEcl = () => {
        setStageSixPostition(2); // show loading or computing state

        calculateECL(loanID)
            .then((res) => {
                setstageSixTableHeaders(res.data.ECLHeaders);
                const body = res.data.ECLTable.map(row => Object.values(row));
                setstageSixTableBody(body);
                setStageSixData(res.data);
                setStageSixPostition(3); // move to final view
            })
            .catch((err) => {
                console.error("ECL calculation failed:", err);
                setStageSixPostition(1); // go back to initial or show error
        });
    };

    // View Working Data 
    const [viewWorkTab, setviewWorkTab]  = useState(1)
    const [viewWorkPD, setviewWorkPD]  = useState()
    const [viewWorkLGD, setviewWorkLGD] = useState()
    const [viewWorkFLF, setviewWorkFLF] = useState()

    useEffect(() => {

        // Pre fill's the data
        getLoansData(loanID).then(Response => {
            let secanrioId = Response.data.loan.loanECLScenarioID
            // stage two first select
            let stageVal = Response.data.loan.loanECLStageColumn
            setstageTwoStageOptionValue(stageVal)
            
            let outStandLoanAmount = Response.data.loan.loanEIROutstandingColumns
            setoutStandingLoanAmount(outStandLoanAmount)

            setstageOneScenarioId(secanrioId)

        })

        getAllLoanECLScenario(companyID).then(Response => {
            let loansList = Response.data.loanECLScenarioList;

            // Map loan list to dropdown format
            const formattedOptions = loansList.map(loanItem => ({
                value: loanItem._id,
                label: loanItem.name
            }));

            setStageOneOptions(formattedOptions);
        });

        // stage two api
        getLoanMapping(loanID, setloanID).then(Response => {
            let loansList = Response.data.fields;

            const stageTwoformattedOptions = loansList?.map(loanItem => ({
                value: loanItem,
                label: loanItem
            }));

            setstageTwoOptions(stageTwoformattedOptions)

        })


        // confirmPDData(loanID, setloanID).then(Response => {
        //     let confirmPdData = Response.data.PDTable;

        //     if (confirmPdData.length > 0) {
        //         const firstRow = confirmPdData[0];
        //         const headers = Object.keys(firstRow);
        //         const body = confirmPdData.map(row => Object.values(row));

        //         setstageThreeTableHeaders(headers);
        //         setstageThreeTableBody(body);
        //         setstageThreeData(confirmPdData);
        //     }
        // });


        // confirmLGDData(loanID, setloanID).then(Response => {
        //     let confirmLGDData = Response.data.PDTable;

        //     if (confirmLGDData.length > 0) {
        //         const firstRow = confirmLGDData[0];
        //         const headers = Object.keys(firstRow);
        //         const body = confirmLGDData.map(row => Object.values(row));

        //         setstageFourTableHeaders(headers);
        //         setstageFourTableBody(body);
        //         setstageFourData(confirmLGDData);
        //     }

        // })

        // confirmFLFData(loanID, setloanID).then(Response => {
        //     let confirmFLFDt = Response.data.PDTable;

        //     if (confirmFLFDt.length > 0) {
        //         const firstRow = confirmFLFDt[0];
        //         const headers = Object.keys(firstRow);
        //         const body = confirmFLFDt.map(row => Object.values(row));

        //         setstageFiveTableHeaders(headers);
        //         setstageFiveTableBody(body);
        //         setstageFiveData(confirmFLFDt);
        //     }

        // })

        // View Working Data
        viewWorking(loanID, setloanID).then(Response => {
            let viewWorkingPD = Response.data.PDWorkings;
            let viewWorkingLGD = Response.data.LGDWorkings;
            let viewWorkingFLF = Response.data.FLFWorkings;

                setviewWorkPD(viewWorkingPD)
                setviewWorkLGD(viewWorkingLGD)
                setviewWorkFLF(viewWorkingFLF)

            // }

        })

    }, 
    [companyID]);


    // useEffect(() => {
    //     console.log('stageTwoStageOptionValue ::', stageTwoStageOptionValue);
    // },[stageTwoStageOptionValue])

    // useEffect(() => {
    //     console.log('outStandingLoanAmount ::', outStandingLoanAmount);
    // },[outStandingLoanAmount])



    return (
        <div style={{ display: 'flex' }}>
            <LoandSideBar
                id = {id}
                companyId={companyId}
                activeTab={'Compute Calculations'}
                subMenuItem={'ECL'}
            />

            <div className={loanCss.mainContainer}>

                <EclHeader
                    ActiveStage={ActiveStage}
                    setActiveStage={setActiveStage}
                    companyID={companyID}
                    loanID={loanID}
                />

                {numberofStages.includes(ActiveStage) ? (
                        <StageNumberBadge
                            ActiveStage={ActiveStage}
                            setActiveStage={setActiveStage}
                        />
                ) : ''}

                {/* <div className={ numberofStages.includes(ActiveStage) ? loanCss.subContainer : loanCss.subCatgeoryContainer}> */}
                <div className={`${numberofStages.includes(ActiveStage) ? loanCss.subContainer : loanCss.subCatgeoryContainer} ${ActiveStage !== 1 ? (ActiveStage === 6 ? loanCss.tableloanlistEcl : loanCss.tableEcl) : ''}`}>
                



                    <div className={
                            numberofStages.includes(ActiveStage)
                                ? loanCss.stagesContantHoldContainer
                                : loanCss.stagesTwoCategoryContantHoldContainerNoMargTp
                            }>

                        {
                            ActiveStage === 1
                            ?
                                <StageOne
                                    stageOneOptions={stageOneOptions}
                                    stageOneScenarioId={stageOneScenarioId}
                                    setstageOneScenarioId={setstageOneScenarioId}
                                />
                            :

                            ActiveStage === 2
                                ?
                                    <StageTwo
                                        stageTwoOptions={stageTwoOptions}
                                        setstageTwoOptions={setstageTwoOptions}

                                        stageTwoStageOptionValue={stageTwoStageOptionValue}
                                        setstageTwoStageOptionValue={setstageTwoStageOptionValue}
                                        outStandingLoanAmount={outStandingLoanAmount}
                                        setoutStandingLoanAmount={setoutStandingLoanAmount}
                                    />
                                :

                            ActiveStage === 3 
                                ?
                                    <StageThree
                                        loanID={loanID}
                                        // stageThreeTableHeaders={stageThreeTableHeaders}
                                        // stageThreeTableBody={stageThreeTableBody}
                                    /> 
                                :

                            ActiveStage === 4 
                                ? 
                                    <StageFour 
                                        loanID={loanID}
                                        // stageFourTableHeaders={stageFourTableHeaders}
                                        // stageFourTableBody={stageFourTableBody}
                                    /> 
                                :

                            ActiveStage === 'view' 
                                ? 
                                    <StageSixViewWork 
                                        viewWorkTab={viewWorkTab} 
                                        setviewWorkTab={setviewWorkTab}
                                        stageSixTableHeaders={stageSixTableHeaders}
                                        stageSixTableBody={stageSixTableBody}
                                        viewWorkPD={viewWorkPD}
                                        viewWorkLGD={viewWorkLGD}
                                        viewWorkFLF={viewWorkFLF}
                                    /> 
                                :

                            ActiveStage === 5 
                                ? 
                                    <StageFive 
                                        loanID={loanID}
                                        // stageFiveTableHeaders={stageFiveTableHeaders}
                                        // stageFiveTableBody={stageFiveTableBody}
                                    /> 
                                :

                            ActiveStage === 6 
                                ? 
                                    <StageSix
                                        loanID={loanID}
                                        ActiveStage={ActiveStage}
                                        setActiveStage={setActiveStage}
                                        StageSixPostition={StageSixPostition} 
                                        setStageSixPostition={setStageSixPostition}
                                        computeEcl={computeEcl}
                                        stageSixTableHeaders={stageSixTableHeaders}
                                        stageSixTableBody={stageSixTableBody}
                                    /> 
                                :

                            ActiveStage === 7 
                                ? 
                                    <StageSeven /> 
                                :
                            null
                        }

                    </div>

                </div>

                {numberofStages.includes(ActiveStage) ? (
                        <EclFooter
                            ActiveStage={ActiveStage}
                            setActiveStage={setActiveStage}
                            loanID={loanID}
                            stageOneScenarioId={stageOneScenarioId}
                            stageTwoStageOptionValue={stageTwoStageOptionValue}
                            outStandingLoanAmount={outStandingLoanAmount}
                        />
                ) : ''}

            </div>

        </div>
    );
};

export default ReceivablesRegisterEcl;


const StageNumberBadge = ({
    ActiveStage,
    setActiveStage,
    }) => {

    // === DEFAULT CLASSES ===
let outerBadge1 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr} ${loanCss.badge}`;
let innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`;
let badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.inactiveBadgeBgClr}`;
let content1 = 1;

let outerBadge2 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr} ${loanCss.badge}`;
let innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`;
let badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.inactiveBadgeBgClr}`;
let content2 = 2;

let outerBadge3 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr} ${loanCss.badge}`;
let innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`;
let badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.inactiveBadgeBgClr}`;
let content3 = 3;

let outerBadge4 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr} ${loanCss.badge}`;
let innerBadge4 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`;
let badgeConnecter4 = `${loanCss.numbConnterStart4} ${loanCss.inactiveBadgeBgClr}`;
let content4 = 4;

let outerBadge5 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr} ${loanCss.badge}`;
let innerBadge5 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`;
let badgeConnecter5 = `${loanCss.numbConnterStart5} ${loanCss.inactiveBadgeBgClr}`;
let content5 = 5;

let outerBadge6 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr} ${loanCss.badge}`;
let innerBadge6 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`;
let badgeConnecter6 = `${loanCss.numbConnterStart6} ${loanCss.inactiveBadgeBgClr}`;
let content6 = 6;

let outerBadge7 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr} ${loanCss.badge}`;
let innerBadge7 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`;
let badgeConnecter7 = `${loanCss.numbConnterStart7} ${loanCss.inactiveBadgeBgClr}`;
let content7 = 7;

// === ACTIVE STAGE CHECK ===
if (ActiveStage === 1) {
    outerBadge1 = `${loanCss.numBadge} ${loanCss.activeBadegClr} ${loanCss.badge}`;
    badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.activeBadgeBgClr}`;

    // badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.lastInActiverBar}`;
}

else if (ActiveStage === 2) {
    outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.completedBadgConnecterClr}`;
    content1 = <CompleteECLIcon />;

    outerBadge2 = `${loanCss.numBadge} ${loanCss.activeBadegClr} ${loanCss.badge}`;
    badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.middleActiveBar}`;

    badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.lastInActiverBar}`;
}

else if (ActiveStage === 3) {
    outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.fullCompletedBadgConnecterClr}`;
    content1 = <CompleteECLIcon />;

    outerBadge2 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.completedBadgConnecterClr}`;
    content2 = <CompleteECLIcon />;

    outerBadge3 = `${loanCss.numBadge} ${loanCss.activeBadegClr} ${loanCss.badge}`;
    badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.middleActiveBar}`;

    badgeConnecter4 = `${loanCss.numbConnterStart4} ${loanCss.lastInActiverBar}`;
}

else if (ActiveStage === 4) {
    outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.fullCompletedBadgConnecterClr}`;
    content1 = <CompleteECLIcon />;

    outerBadge2 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.fullCompletedBadgConnecterClr}`;
    content2 = <CompleteECLIcon />;

    outerBadge3 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.completedBadgConnecterClr}`;
    content3 = <CompleteECLIcon />;

    outerBadge4 = `${loanCss.numBadge} ${loanCss.activeBadegClr} ${loanCss.badge}`;
    badgeConnecter4 = `${loanCss.numbConnterStart4} ${loanCss.middleActiveBar}`;

    badgeConnecter5 = `${loanCss.numbConnterStart5} ${loanCss.lastInActiverBar}`;
}

else if (ActiveStage === 5) {
    outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.fullCompletedBadgConnecterClr}`;
    content1 = <CompleteECLIcon />;

    outerBadge2 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.fullCompletedBadgConnecterClr}`;
    content2 = <CompleteECLIcon />;

    outerBadge3 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.fullCompletedBadgConnecterClr}`;
    content3 = <CompleteECLIcon />;

    outerBadge4 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge4 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter4 = `${loanCss.numbConnterStart4} ${loanCss.completedBadgConnecterClr}`;
    content4 = <CompleteECLIcon />;

    outerBadge5 = `${loanCss.numBadge} ${loanCss.activeBadegClr} ${loanCss.badge}`;
    badgeConnecter5 = `${loanCss.numbConnterStart5} ${loanCss.middleActiveBar}`;

    badgeConnecter6 = `${loanCss.numbConnterStart6} ${loanCss.lastInActiverBar}`;
}

else if (ActiveStage === 6) {
    outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.fullCompletedBadgConnecterClr}`;
    content1 = <CompleteECLIcon />;

    outerBadge2 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.fullCompletedBadgConnecterClr}`;
    content2 = <CompleteECLIcon />;

    outerBadge3 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.fullCompletedBadgConnecterClr}`;
    content3 = <CompleteECLIcon />;

    outerBadge4 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge4 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter4 = `${loanCss.numbConnterStart4} ${loanCss.fullCompletedBadgConnecterClr}`;
    content4 = <CompleteECLIcon />;

    outerBadge5 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge5 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter5 = `${loanCss.numbConnterStart5} ${loanCss.completedBadgConnecterClr}`;
    content5 = <CompleteECLIcon />;

    outerBadge6 = `${loanCss.numBadge} ${loanCss.activeBadegClr} ${loanCss.badge}`;
    badgeConnecter6 = `${loanCss.numbConnterStart6} ${loanCss.middleActiveBar}`;

    badgeConnecter7 = `${loanCss.numbConnterStart6} ${loanCss.lastInActiverBar}`;
}

else if (ActiveStage === 7) {
    outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.fullCompletedBadgConnecterClr}`;
    content1 = <CompleteECLIcon />;

    outerBadge2 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.fullCompletedBadgConnecterClr}`;
    content2 = <CompleteECLIcon />;

    outerBadge3 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.fullCompletedBadgConnecterClr}`;
    content3 = <CompleteECLIcon />;

    outerBadge4 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge4 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter4 = `${loanCss.numbConnterStart4} ${loanCss.fullCompletedBadgConnecterClr}`;
    content4 = <CompleteECLIcon />;

    outerBadge5 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge5 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter5 = `${loanCss.numbConnterStart5} ${loanCss.fullCompletedBadgConnecterClr}`;
    content5 = <CompleteECLIcon />;

    outerBadge6 = `${loanCss.numBadge} ${loanCss.completeBadgeClr} ${loanCss.badge}`;
    innerBadge6 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`;
    badgeConnecter6 = `${loanCss.numbConnterStart6} ${loanCss.completedBadgConnecterClr}`;
    content6 = <CompleteECLIcon />;

    outerBadge7 = `${loanCss.numBadge} ${loanCss.activeBadegClr} ${loanCss.badge}`;
    badgeConnecter7 = `${loanCss.numbConnterStart7} ${loanCss.middleActiveBar}`;
}

    return (
        <div className={loanCss.numBadgeMainContainer}>
            <div className={loanCss.numberContainer}>
                <div onClick={() => {}} key={1} className={`${loanCss.numBadgeContainer} ${loanCss.badgeContainerOne}`} style={{ width: 'calc(8%)' }}>
                    <div className={badgeConnecter1}></div>
                    <div className={`${outerBadge1} ${loanCss.badge}`}>
                        <div className={innerBadge1}>{content1}</div>
                    </div>
                    <div className={`${loanCss.numberText} ${loanCss.numberText1}`}>Scenario</div>
                </div>
                <div onClick={() => {}} key={2} className={`${loanCss.numBadgeContainer} ${loanCss.badgeContainerTwo}`}>
                    <div className={badgeConnecter2}></div>
                    <div className={`${outerBadge2} ${loanCss.badge}`}>
                        <div className={innerBadge2}>{content2}</div>
                    </div>
                    <div className={`${loanCss.numberText} ${loanCss.numberText2}`}>confirm fields</div>
                </div>
                <div onClick={() => {}} key={3} className={`${loanCss.numBadgeContainer} ${loanCss.badgeContainerThree}`}>
                    <div className={badgeConnecter3}></div>
                    <div className={`${outerBadge3} ${loanCss.badge}`}>
                        <div className={innerBadge3}>{content3}</div>
                    </div>
                    <div className={`${loanCss.numberText} ${loanCss.numberText3}`}>user confirmation <br /> (pd)</div>
                </div>
                <div onClick={() => {}} key={4} className={`${loanCss.numBadgeContainer} ${loanCss.badgeContainerFour}`}>
                    <div className={badgeConnecter4}></div>
                    <div className={`${outerBadge4} ${loanCss.badge}`}>
                        <div className={innerBadge4}>{content4}</div>
                    </div>
                    <div className={`${loanCss.numberText} ${loanCss.numberText4}`}>user confirmation <br /> (lgd)</div>
                </div>
                <div onClick={() => {}} key={5} className={`${loanCss.numBadgeContainer} ${loanCss.badgeContainerFive}`}>
                    <div className={badgeConnecter5}></div>
                    <div className={`${outerBadge5} ${loanCss.badge}`}>
                        <div className={innerBadge5}>{content5}</div>
                    </div>
                    <div className={`${loanCss.numberText} ${loanCss.numberText5}`}>user confirmation <br /> (FLF)</div>
                </div>
                <div onClick={() => {}} key={6} className={`${loanCss.numBadgeContainer} ${loanCss.badgeContainerSix}`}>
                    <div className={badgeConnecter6}></div>
                    <div className={`${outerBadge6} ${loanCss.badge}`}>
                        <div className={innerBadge6}>{content6}</div>
                    </div>
                    <div className={`${loanCss.numberText} ${loanCss.numberText6}`}>compute Ecl</div>
                </div>
                <div onClick={() => {}} key={7} className={`${loanCss.numBadgeContainer} ${loanCss.badgeContainerSeven}`} style={{ width: 'calc(8%)' }}>
                    <div className={badgeConnecter7}></div>
                    <div className={`${outerBadge7} ${loanCss.badge}`}>
                        <div className={innerBadge7}>{content7}</div>
                    </div>
                    <div className={`${loanCss.numberText} ${loanCss.numberText7}`}>pass ecl entries</div>
                </div>
            </div>
        </div>

    );
};



// const StageNumberBadge = ({
//     ActiveStage,
//     setActiveStage,
//     }) => {

//         var outerBadge1 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr}`
//         var innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//         var badgeConnecter1 = `${loanCss.numbConnterStart2} ${loanCss.inactiveBadgeBgClr}`
//         var content1 = 1

//         var outerBadge2 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr}`
//         var innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//         var badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.inactiveBadgeBgClr}`
//         var content2 = 2

//         var outerBadge3 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr}`
//         var innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//         var badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.inactiveBadgeBgClr}`
//         var content3 = 3

//         var outerBadge4 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr}`
//         var innerBadge4 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//         var badgeConnecter4 = `${loanCss.numbConnterStart4} ${loanCss.inactiveBadgeBgClr}`
//         var content4 = 4

//         var outerBadge5 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr}`
//         var innerBadge5 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//         var badgeConnecter5 = `${loanCss.numbConnterStart5} ${loanCss.inactiveBadgeBgClr}`
//         var content5 = 5

//         var outerBadge6 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr}`
//         var innerBadge6 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//         var badgeConnecter6 = `${loanCss.numbConnterStart6} ${loanCss.inactiveBadgeBgClr}`
//         var content6 = 6

//         var outerBadge7 = `${loanCss.numBadge} ${loanCss.inactiveBadgeBgClr}`
//         var innerBadge7 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//         var badgeConnecter7 = `${loanCss.numbConnterStart7} ${loanCss.inactiveBadgeBgClr}`
//         var content7 = 7

//         if (ActiveStage === 1) {
//                 outerBadge1 = `${loanCss.numBadge} ${loanCss.activeBadegClr}`;
//                 innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//                 badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.activeBadgeBgClr}`
//                 content1 = 1
//             }
//             else if (ActiveStage === 2) {
//                 outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`;
//                 innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.completedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${loanCss.numBadge} ${loanCss.activeBadegClr}`
//                 innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//                 badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.activeBadgeBgClr}`
//             }
//             else if (ActiveStage === 3) {
//                 outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`;
//                 innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.completedBadgConnecterClr}`
//                 content2 = <CompleteECLIcon />

//                 outerBadge3 = `${loanCss.numBadge} ${loanCss.activeBadegClr}`
//                 innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//                 badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.activeBadgeBgClr}`
//             }
//             else if (ActiveStage === 4) {
//                 outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`;
//                 innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content2 = <CompleteECLIcon />

//                 outerBadge3 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.completedBadgConnecterClr}`
//                 content3 = <CompleteECLIcon />

//                 outerBadge4 = `${loanCss.numBadge} ${loanCss.activeBadegClr}`
//                 innerBadge4 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//                 badgeConnecter4 = `${loanCss.numbConnterStart4} ${loanCss.activeBadgeBgClr}`
//             }
//             else if (ActiveStage === 5) {
//                 outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`;
//                 innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content2 = <CompleteECLIcon />

//                 outerBadge3 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content3 = <CompleteECLIcon />

//                 outerBadge4 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge4 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter4 = `${loanCss.numbConnterStart4} ${loanCss.completedBadgConnecterClr}`
//                 content4 = <CompleteECLIcon />

//                 outerBadge5 = `${loanCss.numBadge} ${loanCss.activeBadegClr}`
//                 innerBadge5 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//                 badgeConnecter5 = `${loanCss.numbConnterStart5} ${loanCss.activeBadgeBgClr}`
//             }
//             else if (ActiveStage === 6) {
//                 outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`;
//                 innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content2 = <CompleteECLIcon />

//                 outerBadge3 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content3 = <CompleteECLIcon />

//                 outerBadge4 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge4 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter4 = `${loanCss.numbConnterStart4} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content4 = <CompleteECLIcon />

//                 outerBadge5 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge5 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter5 = `${loanCss.numbConnterStart5} ${loanCss.completedBadgConnecterClr}`
//                 content5 = <CompleteECLIcon />

//                 outerBadge6 = `${loanCss.numBadge} ${loanCss.activeBadegClr}`
//                 innerBadge6 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//                 badgeConnecter6 = `${loanCss.numbConnterStart6} ${loanCss.activeBadgeBgClr}`
//             }
//             else if (ActiveStage === 7) {
//                 outerBadge1 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`;
//                 innerBadge1 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter1 = `${loanCss.numbConnterStart1} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge2 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter2 = `${loanCss.numbConnterStart2} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content2 = <CompleteECLIcon />

//                 outerBadge3 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge3 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter3 = `${loanCss.numbConnterStart3} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content3 = <CompleteECLIcon />

//                 outerBadge4 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge4 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter4 = `${loanCss.numbConnterStart4} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content4 = <CompleteECLIcon />

//                 outerBadge5 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge5 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter5 = `${loanCss.numbConnterStart5} ${loanCss.fullCompletedBadgConnecterClr}`
//                 content5 = <CompleteECLIcon />

//                 outerBadge6 = `${loanCss.numBadge} ${loanCss.completeBadgeClr}`
//                 innerBadge6 = `${loanCss.numBadgeInner} ${loanCss.completeBadgeClr}`
//                 badgeConnecter6 = `${loanCss.numbConnterStart6} ${loanCss.completedBadgConnecterClr}`
//                 content6 = <CompleteECLIcon />

//                 outerBadge7 = `${loanCss.numBadge} ${loanCss.activeBadegClr}`
//                 innerBadge7 = `${loanCss.numBadgeInner} ${loanCss.innerBadgeBgClr}`
//                 badgeConnecter7 = `${loanCss.numbConnterStart7} ${loanCss.activeBadgeBgClr}`
//             }


//     return (

//         <div className={loanCss.numBadgeMainContainer}>
//             <div className={loanCss.numberContainer}>
//                 <div onClick={ () => {} } key={1} className={outerBadge1}>
//                     <div className={badgeConnecter1}></div>
//                     <div className={innerBadge1}>{content1}</div>
//                     <div className={`${loanCss.numberText} ${loanCss.numberText1}`}>Scenario</div>
//                 </div>
//                 <div onClick={ () => {} } key={2} className={outerBadge2}>
//                     <div className={badgeConnecter2}></div>
//                     <div className={innerBadge2}>{content2}</div>
//                     <div className={`${loanCss.numberText} ${loanCss.numberText2}`}>confirm fields</div>
//                 </div>
//                 <div onClick={ () => {} } key={3} className={outerBadge3}>
//                     <div className={badgeConnecter3}></div>
//                     <div className={innerBadge3}>{content3}</div>
//                     <div className={`${loanCss.numberText} ${loanCss.numberText3}`}>user confirmation <br /> (pd) </div>
//                 </div>
//                 <div onClick={ () => {} } key={4} className={outerBadge4}>
//                     <div className={badgeConnecter4}></div>
//                     <div className={innerBadge4}>{content4}</div>
//                     <div className={`${loanCss.numberText} ${loanCss.numberText4}`}>user confirmation <br /> (lgd)</div>
//                 </div>
//                 <div onClick={ () => {} } key={5} className={outerBadge5}>
//                     <div className={badgeConnecter5}></div>
//                     <div className={innerBadge5}>{content5}</div>
//                     <div className={`${loanCss.numberText} ${loanCss.numberText5}`}>user confirmation <br /> (FLF)</div>
//                 </div>
//                 <div onClick={ () => {} } key={6} className={outerBadge6}>
//                     <div className={badgeConnecter6}></div>
//                     <div className={innerBadge6}>{content6}</div>
//                     <div className={`${loanCss.numberText} ${loanCss.numberText6}`}>compute Ecl</div>
//                 </div>
//                 <div onClick={ () => {} } key={7} className={outerBadge7}>
//                     <div className={badgeConnecter7}></div>
//                     <div className={innerBadge7}>{content7}</div>
//                     <div className={`${loanCss.numberText} ${loanCss.numberText7}`}>pass ecl entries</div>
//                 </div>

//             </div>
//         </div>
//     );
// };



const StageOne = ({
    stageOneOptions,
    stageOneScenarioId,
    setstageOneScenarioId
}) => {

    return(
        <div className={loanCss.stage1MainContainer}>
            <div className={loanCss.stage1SubContainer}>

                <div>
                    <span className={loanCss.scenarioLabelClr}>Scenario</span>
                    <div className={loanCss.editPolicyContainer}>
                        <Select
                            components={{ IndicatorSeparator: () => null }} // remove separator
                            value={stageOneScenarioId ? stageOneOptions.find(option => option.value === stageOneScenarioId) : stageOneOptions?.[0]}
                            defaultValue={stageOneOptions?.[0]}
                            onChange={(selectedOption) => setstageOneScenarioId(selectedOption.value)}
                            options={stageOneOptions}
                            placeholder="Select Scenario"
                            name="status"
                            className={`mt-0 ${loanCss.scenarioSelect}`}
                            classNamePrefix="select"
                            styles={customStyles}
                            isClearable={false}
                            isSearchable={false}
                        />
                        <div className={loanCss.stageOneEditScenarioContainer}>
                            <span>
                                <EditIcon className={loanCss.scenarioEditIcon} />
                            </span>
                            <span className={loanCss.customGreenText}>
                                Edit in Policies
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )

}


const StageTwo = ({
    stageTwoOptions,
    stageTwoStageOptionValue,
    setstageTwoStageOptionValue,
    outStandingLoanAmount,
    setoutStandingLoanAmount,
}) => {

    return(
        <div className={loanCss.stageTwoMainContainer}>

            <div className={loanCss.stageTwoSubContainer}>
                <div className={loanCss.stageTwoStageSelectContainer}>
                    <span className={loanCss.scenarioLabelClr}>Stage</span>
                    <Select
                        components={{ IndicatorSeparator: () => null }} // remove separator
                        defaultValue={stageTwoOptions?.[0]}
                        onChange={(selectedOption) => setstageTwoStageOptionValue(selectedOption.value)}
                        // value={stageTwoOptions?.find(opt => opt.value === stageTwoStageOptionValue) || stageTwoOptions?.[0]}
                        value={stageTwoStageOptionValue ? stageTwoOptions.find(option => option.value === stageTwoStageOptionValue) : stageTwoOptions?.[0]}
                        options={stageTwoOptions}
                        placeholder="Select Scenario"
                        name="status"
                        className={`mt-0 ${loanCss.StageTwoSelect}`}
                        classNamePrefix="select"
                        styles={customStyles}
                        isClearable={false}
                        isSearchable={false}
                    />
                    <span className={loanCss.stageTwoInptDesc}>Note or description for particular field</span>
                </div>
            </div>

            <div className={loanCss.stageTwoSubContainer}>
                <div className={loanCss.stageTwoStageSelectContainer}>
                    <span className={loanCss.scenarioLabelClr}>Outstanding Loan Amount</span>
                    <Select
                        components={{ IndicatorSeparator: () => null }} // remove separator
                        defaultValue={stageTwoOptions?.[0]}
                        // value={stageTwoOptions?.find(opt => opt.value === outStandingLoanAmount?.[0]) || stageTwoOptions?.[0]}
                         value={outStandingLoanAmount ? stageTwoOptions.find(option => option.value === outStandingLoanAmount?.[0]) : stageTwoOptions?.[0]}
                        onChange={(selectedOption) => {
                            setoutStandingLoanAmount(prev => {
                                const newValue = selectedOption.value;
                                return prev.includes(newValue) ? prev : [...prev, newValue];
                            });
                        }}
                        options={stageTwoOptions}
                        placeholder="Select Scenario"
                        name="status"
                        className={`mt-0 ${loanCss.StageTwoSelect}`}
                        classNamePrefix="select"
                        styles={customStyles}
                        isClearable={false}
                        isSearchable={false}
                    />
                    <span className={loanCss.stageTwoInptDesc}>Note or description for particular field</span>
                </div>
            </div>

        </div>
    )

}


const StageThree = ({
    // stageThreeTableHeaders,
    // stageThreeTableBody,
    loanID
}) => {

    const [stageThreeData , setstageThreeData] = useState()
    const [stageThreeTableHeaders , setstageThreeTableHeaders] = useState([])
    const [stageThreeTableBody , setstageThreeTableBody] = useState([])


    useEffect(() => {
        confirmPDData(loanID).then(Response => {
        let confirmPdData = Response.data.PDTable;

        if (confirmPdData.length > 0) {
            const firstRow = confirmPdData[0];
            const headers = Object.keys(firstRow);
            const body = confirmPdData.map(row => Object.values(row));

            setstageThreeTableHeaders(headers);
            setstageThreeTableBody(body);
            setstageThreeData(confirmPdData);
        }
    });
    },
    [])

    
    return(
        <div className={loanCss.stageThreeMainContainer}>
            {/* <div className={loanCss.stageThreeTableLabel}>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Soluta, facere.
            </div> */}

            {/* NEW WRAPPER */}
            <div className={loanCss.stageThreeScrollWrapper}>
                <div className={loanCss.stageThreeTable}>
                <div className={loanCss.stageThreeTableHeader}>
                    {stageThreeTableHeaders.map((header, index) => (
                        // <div key={index} className={loanCss.stageThreeTableHeaderItem}>
                        <div key={index} className={`${loanCss.stageThreeTableHeaderItem} ${index > 0 ? loanCss.checkboxEcl : ''}`}>
                            {header}
                        </div>
                    ))}
                </div>

                <div className={loanCss.stageThreeTableBody}>
                        {stageThreeTableBody.map((row, rowIndex) => (
                            <React.Fragment >
                                <div className={loanCss.stageThreeTableBodyRow} key={`${rowIndex}`}>
                                    {row.map((cell, cellIndex) => (
                                        // <div key={`${rowIndex}-${cellIndex}`} className={loanCss.stageThreeTableBodyItem}>
                                         <div key={`${rowIndex}-${cellIndex}} className={${loanCss.stageThreeTableBodyItem} ${['Yes', 'No', 'Warning'].includes(cell) ? loanCss.checkboxEcl : ''}`}>

                                            {cell === 'Yes' ? (
                                                <input type="checkbox" checked readOnly />
                                            ) : cell === 'No' ? (
                                                <input type="checkbox" readOnly />
                                            ) : cell === 'Warning' ? (
                                                <div><Warning />&nbsp;Warning</div>
                                            ) : (
                                                cell
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </React.Fragment>
                        ))}
                </div>
                </div>
            </div>
        </div>
    )

}



const StageFour = ({
    // stageFourTableHeaders,
    // stageFourTableBody,
    loanID
}) => {

    const [stageFourData , setstageFourData] = useState()
    const [stageFourTableHeaders , setstageFourTableHeaders] = useState([])
    const [stageFourTableBody , setstageFourTableBody] = useState([])

    useEffect(() => {
        confirmLGDData(loanID).then(Response => {
            let confirmLGDData = Response.data.PDTable;
    
            if (confirmLGDData.length > 0) {
                const firstRow = confirmLGDData[0];
                const headers = Object.keys(firstRow);
                const body = confirmLGDData.map(row => Object.values(row));
    
                setstageFourTableHeaders(headers);
                setstageFourTableBody(body);
                setstageFourData(confirmLGDData);
            }
    
        })
    },
    [])


    return(
        <div className={loanCss.stageThreeMainContainer}>
            {/* <div className={loanCss.stageThreeTableLabel}>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Soluta, facere.
            </div> */}

            {/* NEW WRAPPER */}
            <div className={loanCss.stageThreeScrollWrapper}>
                <div className={loanCss.stageThreeTable}>
                <div className={loanCss.stageThreeTableHeader}>
                    {stageFourTableHeaders.map((header, index) => (
                        <div key={index} className={loanCss.stageThreeTableHeaderItem}>
                            {header}
                        </div>
                    ))}
                </div>

                <div className={loanCss.stageThreeTableBody}>
                        {stageFourTableBody.map((row, rowIndex) => (
                            <React.Fragment >
                                <div className={loanCss.stageThreeTableBodyRow} key={`${rowIndex}`}>
                                    {row.map((cell, cellIndex) => (
                                    <div key={`${rowIndex}-${cellIndex}`} className={loanCss.stageThreeTableBodyItem}>
                                        {cell === 'Yes' ? (
                                            <input type="checkbox" checked readOnly />
                                        ) : cell === 'No' ? (
                                            <input type="checkbox" readOnly />
                                        ) : cell === 'Warning' ? (
                                            <div><Warning />&nbsp;Warning</div>
                                        ) : (
                                            cell
                                        )}
                                    </div>
                                    ))}
                                </div>
                            </React.Fragment>
                        ))}
                </div>
                </div>
            </div>
        </div>
    )

}



const StageFive = ({
    // stageFiveTableHeaders,
    // stageFiveTableBody
    loanID
}) => {

    const [stageFiveData , setstageFiveData] = useState()
    const [stageFiveTableHeaders , setstageFiveTableHeaders] = useState([])
    const [stageFiveTableBody , setstageFiveTableBody] = useState([])

    useEffect(()=> {
        confirmFLFData(loanID).then(Response => {
            let confirmFLFDt = Response.data.PDTable;

            if (confirmFLFDt.length > 0) {
                const firstRow = confirmFLFDt[0];
                const headers = Object.keys(firstRow);
                const body = confirmFLFDt.map(row => Object.values(row));

                setstageFiveTableHeaders(headers);
                setstageFiveTableBody(body);
                setstageFiveData(confirmFLFDt);
            }

        })
    },
    [])

    return(
        <div className={loanCss.stageThreeMainContainer}>
            {/* <div className={loanCss.stageThreeTableLabel}>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Soluta, facere.
            </div> */}

            {/* NEW WRAPPER */}
            <div className={loanCss.stageThreeScrollWrapper}>
                <div className={loanCss.stageThreeTable}>
                <div className={loanCss.stageThreeTableHeader}>
                    {stageFiveTableHeaders.map((header, index) => (
                        <div key={index} className={loanCss.stageThreeTableHeaderItem}>
                            {header}
                        </div>
                    ))}
                </div>

                <div className={loanCss.stageThreeTableBody}>
                        {stageFiveTableBody.map((row, rowIndex) => (
                            <React.Fragment >
                                <div className={loanCss.stageThreeTableBodyRow} key={`${rowIndex}`}>
                                    {row.map((cell, cellIndex) => (
                                    <div key={`${rowIndex}-${cellIndex}`} className={loanCss.stageThreeTableBodyItem}>
                                        {cell === 'Yes' ? (
                                            <input type="checkbox" checked readOnly />
                                        ) : cell === 'No' ? (
                                            <input type="checkbox" readOnly />
                                        ) : cell === 'Warning' ? (
                                            <div><Warning />&nbsp;Warning</div>
                                        ) : (
                                            cell
                                        )}
                                    </div>
                                    ))}
                                </div>
                            </React.Fragment>
                        ))}
                </div>
                </div>
            </div>
        </div>
    )

}



const StageSix = ({
    loanID,
    ActiveStage,
    setActiveStage,
    StageSixPostition, 
    setStageSixPostition,
    computeEcl,
    stageSixTableHeaders,
    stageSixTableBody
    }) => {

    const StageSixStartCompute = () =>{
        return(
            <div className={loanCss.computeMainContainer}>
                <div className={loanCss.computeContainer}>
                    <div className={loanCss.DedupecomputText}>Lorem ipsum dolor sit amet consectetur.Scelerisque</div>
                    <div className={loanCss.DedupecomputText}>luctus morbi odio orci. Tellus risus et id.</div>
                    <div>
                        <button type="button"
                            style={{ marginTop:'10px' }} className={`${loanCss.stageSixBtn} ${loanCss.stageSixPrimaryBtn}`}
                            onClick={() => {computeEcl()}}
                        >Compute ECL</button> </div>
                </div>
            </div>
        )
    }

    const StageSixLoader = () => {
        return(
            <div className={loanCss.computeMainContainer}>
                <div className={loanCss.computeContainerLoader}>
                    <LoaderIcon className={loanCss.spininfinite} />
                    <div className={loanCss.computText}>Computation in progress</div>
                    <div className={loanCss.computText}>This might take a few minutes, Please wait...</div>
                </div>
            </div>
        )
    }

    const StageSixDataView = () => {
        return(
            <div className={loanCss.stageSixMainContainer}>
                <div className={loanCss.stageSixbtnContainer}>
                    <div className={loanCss.stageSixbtnLeftContainer}>
                        <button style={{ marginRight : '10px' }} type="button" className={`${loanCss.stageSixbtnBorderRadius} ${loanCss.stageSixBtn} ${loanCss.stageSixSecondaryBtn}`}> <RefershIcon /> Refresh</button>
                        <button className={`${loanCss.stageSixbtnBorderRadius} ${loanCss.stageSixBtn} ${loanCss.stageSixSecondaryBtn}`} type="button">Start Over</button>
                    </div>
                    <div className={loanCss.stageSixbtnRightContainer}>
                        <button type="button"
                            className={`${loanCss.stageSixbtnBorderRadius} ${loanCss.stageSixBtn} ${loanCss.stageSixSecondaryBtn}`}
                            onClick={() => { setActiveStage('view') }}
                        >View Workings</button>
                        <button 
                            style={{ marginLeft : '10px' }} 
                            type="button" 
                            className={`${loanCss.stageSixbtnBorderRadius} ${loanCss.stageSixBtn} ${loanCss.stageSixPrimaryBtn}`}
                            onClick={() => addLoanToListing(loanID)}
                            >Add columns to loan listing</button>
                    </div>
                </div>
                <div className={loanCss.stageThreeScrollWrapper}>
                    <div className={loanCss.stageThreeTable}>
                        <div className={loanCss.stageThreeTableHeader}>
                            {stageSixTableHeaders?.map((header, index) => (
                                <div key={index} className={loanCss.stageThreeTableHeaderItem}>
                                    {header}
                                </div>
                            ))}
                        </div>

                        <div className={loanCss.stageSixTableBody}>
                            {stageSixTableBody?.map((row, rowIndex) => (
                                <React.Fragment >
                                    <div className={loanCss.stageThreeTableBodyRow} key={`${rowIndex}`}>
                                        {row.map((cell, cellIndex) => (
                                            <div key={`${rowIndex}-${cellIndex}`} className={loanCss.stageThreeTableBodyItem}>
                                                {cell}
                                            </div>
                                        ))}
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    return(
        <React.Fragment>
            {StageSixPostition === 1 && <StageSixStartCompute />}
            {StageSixPostition === 2 && <StageSixLoader />}
            {StageSixPostition === 3 && <StageSixDataView />}
        </React.Fragment>
    )

}


const StageSeven = () => {

    return(
        <div className={loanCss.stageSevenMainContainer}>
            <div className={loanCss.stageSevenOutStandContainer}>
                <div className={loanCss.stageSevenLoansOutstandLabel}>
                    {/* Lorem ipsum dolor sit amet. */}
                </div>
                <div className={loanCss.stageSevenLoanDataCont}>
                    <div className={loanCss.stageSeveOutStandingDataItem}>
                        <div className={loanCss.stageSevenlabel}>
                            Loan Outstanding (Gross)
                        </div>
                        <div>
                            97,84,653
                        </div>
                    </div>
                    <div className={loanCss.stageSeveOutStandingDataItem}>
                        <div className={loanCss.stageSevenlabel}>
                            ECL Amount
                        </div>
                        <div>
                            87,84,653
                        </div>
                    </div>

                    <div className={loanCss.stageSeveoutStandSubCont}>
                        <div className={loanCss.stageSeveOutStandingDataItem}>
                            <div className={loanCss.stageSevenlabel}>
                                ECL as per Ledger
                            </div>
                            <div>
                                <input className={loanCss.stageSevenInpt} type="text" name="" id="" placeholder='Enter Amount...' />
                            </div>
                        </div>

                        <div className={loanCss.stageSeveOutStandingDataItem}>
                            <div className={loanCss.stageSevenlabel}>
                                Amount to be passed
                            </div>
                            <div>
                                87,84,653
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${loanCss.stageSevenOutStandContainer} ${loanCss.mT25}`}>
                <div className={loanCss.stageSevenLoansOutstandLabel}>
                      Suggested Entry
                </div>
                <div className={loanCss.stageSevenLoanDataCont}>
                    <div className={loanCss.stageSeveOutStandingDataItem}>
                        <div className={loanCss.stageSevenlabel}>
                            Provision for ECL
                        </div>
                        <div>
                            97,84,653
                        </div>
                    </div>
                    <div className={loanCss.stageSeveOutStandingDataItem}>
                        <div className={loanCss.stageSevenlabel}>
                            To Expected credit loss account - Loans
                        </div>
                        <div>
                            87,84,653
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}





const StageSixViewWork = ({
    stageSixTableHeaders,
    stageSixTableBody,
    viewWorkPD,
    viewWorkTab, 
    setviewWorkTab,
    viewWorkLGD,
    viewWorkFLF,
}) => {
    
    return(
        <div>
            <div className={loanCss.catgegoryContainer}>
                <div className={ viewWorkTab == 1 ? loanCss.activeCategoryTab : loanCss.inActiveCategoryTab} onClick={() => {setviewWorkTab(1)}}>
                    PD
                </div>
                <div className={ viewWorkTab == 2 ? loanCss.activeCategoryTabNoRadius : loanCss.inActiveCategoryTab} onClick={() => {setviewWorkTab(2)}}>
                    LGD
                </div>
                <div className={ viewWorkTab == 3 ? loanCss.activeCategoryTabNoRadius : loanCss.inActiveCategoryTab} onClick={() => {setviewWorkTab(3)}}>
                    FLF
                </div>
            </div>

            <div className={loanCss.viewWorkContainer}>

                {
                
                    viewWorkTab === 1 
                        ? 
                            <div className={loanCss.tablesContainerViewWork}>
                                {/* <h6>PD</h6> */}
                                {/* <div className={loanCss.viewWorkLabe}>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Deleniti, fugiat!</div> */}

                                {viewWorkPD?.map((tableObj, tableIndex) => (
                                    <div key={tableIndex} className={loanCss.stageThreeScrollWrapper}>
                                        {/* Title */}
                                        <div className={`${loanCss.stageThreeTableTitle} ${loanCss.TableName}`}>
                                            {tableObj?.tableTitle}
                                        </div>
                                        <div className={loanCss.stageThreeTable}>
                                            {/* Headers */}
                                            <div className={loanCss.stageThreeTableHeader}>
                                                {tableObj?.tableHeaders.map((header, index) => (
                                                    <div key={index} className={loanCss.stageThreeTableHeaderItem}>
                                                        {header}
                                                    </div>
                                                ))}
                                            </div>
                                            {/* Body */}
                                            <div className={loanCss.stageViewWork}>
                                                {tableObj?.table.map((rowObj, rowIndex) => (
                                                    <div key={rowIndex} className={loanCss.stageThreeTableBodyRow}>
                                                        {tableObj?.tableHeaders.map((header, cellIndex) => (
                                                            <div key={`${rowIndex}-${cellIndex}`} className={loanCss.stageThreeTableBodyItem}>
                                                                {rowObj[header]}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        :       
                    viewWorkTab === 2
                        ?
                            <div className={loanCss.tablesContainerViewWork}>
                                {/* <h6>LGD</h6> */}
                                {/* <div className={loanCss.viewWorkLabe}>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Deleniti, fugiat!</div> */}

                                {viewWorkLGD?.map((tableObj, tableIndex) => (
                                    <div key={tableIndex} className={loanCss.stageThreeScrollWrapper}>
                                        {/* Title */}
                                        <div className={`${loanCss.stageThreeTableTitle} ${loanCss.TableName}`}>
                                            {tableObj?.tableTitle}
                                        </div>
                                        <div className={loanCss.stageThreeTable}>
                                            {/* Headers */}
                                            <div className={loanCss.stageThreeTableHeader}>
                                                {tableObj?.tableHeaders.map((header, index) => (
                                                    <div key={index} className={loanCss.stageThreeTableHeaderItem}>
                                                        {header}
                                                    </div>
                                                ))}
                                            </div>
                                            {/* Body */}
                                            <div className={loanCss.stageViewWork}>
                                                {tableObj?.table.map((rowObj, rowIndex) => (
                                                    <div key={rowIndex} className={loanCss.stageThreeTableBodyRow}>
                                                        {tableObj?.tableHeaders.map((header, cellIndex) => (
                                                            <div key={`${rowIndex}-${cellIndex}`} className={loanCss.stageThreeTableBodyItem}>
                                                                {rowObj[header]}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        :
                    viewWorkTab === 3
                        ?
                            <div className={loanCss.tablesContainerViewWork}>
                                {/* <h6>FLF</h6> */}
                                {/* <div className={loanCss.viewWorkLabe}>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Deleniti, fugiat!</div> */}

                                {viewWorkFLF?.map((tableObj, tableIndex) => (
                                    <div key={tableIndex} className={loanCss.stageThreeScrollWrapper}>
                                        {/* Title */}
                                        <div className={`${loanCss.stageThreeTableTitle} ${loanCss.TableName}`}>
                                            {tableObj?.tableTitle}
                                        </div>
                                        <div className={loanCss.stageThreeTable}>
                                            {/* Headers */}
                                            <div className={loanCss.stageThreeTableHeader}>
                                                {tableObj?.tableHeaders.map((header, index) => (
                                                    <div key={index} className={loanCss.stageThreeTableHeaderItem}>
                                                        {header}
                                                    </div>
                                                ))}
                                            </div>
                                            {/* Body */}
                                            <div className={loanCss.stageViewWork}>
                                                {tableObj?.table.map((rowObj, rowIndex) => (
                                                    <div key={rowIndex} className={loanCss.stageThreeTableBodyRow}>
                                                        {tableObj?.tableHeaders.map((header, cellIndex) => (
                                                            <div key={`${rowIndex}-${cellIndex}`} className={loanCss.stageThreeTableBodyItem}>
                                                                {rowObj[header]}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        :
                        ''
                }

            </div>

        </div>
    )

}


const EclHeader = ({
    ActiveStage,
    setActiveStage,
    companyID,
    loanID,
    }) => {
    const breadcrumbItems = [
        {
            label: "Loan Register",
            link: `/myfinV2/overview/${loanID}/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "Compute Calculations",
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "ECL",
            className: `${commoncss.nav_cnt_color} clickable`,
        },
    ];
    return(
        // <div className={loanCss.headerContainer}>
        //     <div className={loanCss.eclbreadCumbs}
        //         onClick={() => {
        //             if (ActiveStage === 'view') {
        //                 setActiveStage(6);
        //             }
        //         }}
        //         >
        //         <PervBtnIcon />
        //     </div>
        //     <div className={loanCss.headerBreadCrumbsText}>
        //         Loans
        //     </div>
        //     <div className={loanCss.breadCumbContainer}>
        //         <BreadCrumbsdor />
        //     </div>
        //     <div className={loanCss.headerBreadCrumbsText}>
        //         ECL
        //     </div>
        // </div>
        <Breadcrumb
            addCls="bgTransprent"
            items={breadcrumbItems}
            headerActions={<></>}
            p0={true}
        />
    )
}


const EclFooter = ({

    ActiveStage,
    setActiveStage,

    loanID,
    stageOneScenarioId,

    stageTwoStageOptionValue,
    outStandingLoanAmount

    }) => {

    const routerHistory = useHistory();
    const handleClick = (Link) => {
        routerHistory.push(Link);
    };

    return(
        <div className={loanCss.footerContainer}>
            <div>
                <button
                onClick={() => {handleClick('/myfinv2/company-edit/accounting-policy/10')}}
                className={loanCss.cancelBtn} type="button">Cancel</button>
            </div>
            <div className={loanCss.footerbtnContainer}>
                <button 
                    onClick={() => {
                        if (ActiveStage !== 1) {
                            setActiveStage(ActiveStage - 1);
                        }
                    }}
                    className={loanCss.perviewBtn} 
                    type="button"> 
                    <PervBtnIcon />  
                    Previous
                </button>
                <button 
                    onClick={()=>{
                        if(ActiveStage !== 7){ 
                            if(ActiveStage === 1){
                                selectLoanECLScenario(loanID,stageOneScenarioId)
                            }
                            if(ActiveStage === 2){
                                let stageTwoDataObj = {
                                    'loanECLStageColumn': stageTwoStageOptionValue,
                                    'loanECLOutstandingColumns':outStandingLoanAmount,
                                }
                                setEclFields(loanID, stageTwoDataObj)
                            }
                            setActiveStage(ActiveStage + 1)
                        }
                    }}
                    className={loanCss.saveBtn} 
                    type="button">
                        { ActiveStage === 7 ? 'Finish' : 'Next'}<NextBtnIcon/>
                    </button>
            </div>
        </div>
    )
}




export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    borderColor: '#c2e6d1',
    color: '#b3c0bd',
    boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
    borderWidth: '1px',
    borderRadius: '10px',
    '&:hover': {
      borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#4d6d64',
    fontSize: '14px',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9',
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#4d6d64',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#205a46', 
    ':hover': {
        color: '#205a46',
    },
    }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      color: '#4f665f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '10px',
    boxShadow: '0 0 0 1px #c2e6d1',
    marginTop: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '10px',
  }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? '#c2e6d1'
//       : state.isFocused
//       ? '#f4faf5'
//       : 'transparent',
//     color: '#4f665f',
//     padding: '10px 12px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     borderRadius: '8px',
//     // margin: '4px 6px',
//   }),
option: (provided, state) => ({
  ...provided,
  backgroundColor: state.isFocused
    ? '#f4faf5'
    : 'transparent', 
  color: '#4f665f',
  padding: '10px 12px',
  cursor: 'pointer',
  fontSize: '14px',
  borderRadius: '8px',
}),

  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};

